<div class="week">
  <!-- Kopfzeile -->
  <div class="week-head">
    <div class="gutter"></div>
    <div class="day-head" *ngFor="let day of days" [class.today]="day === today" [class.weekend]="isWeekend(day)">
      {{ dayLabel(day) }}
    </div>
  </div>

  <!-- Ganztägige und mehrtägige Einträge -->
  <div class="allday" *ngIf="allDayLanes > 0">
    <div class="gutter allday-label">Ganztägig</div>
    <div class="allday-grid" [style.grid-template-rows]="'repeat(' + allDayLanes + ', 24px)'">
      <button type="button" class="allday-bar" *ngFor="let bar of allDayBars; trackBy: trackItem"
        [ngClass]="bar.item.kind" [class.locked]="!bar.item.editable && bar.item.kind === 'assignment'"
        [style.grid-column]="(bar.column + 1) + ' / span ' + bar.span" [style.grid-row]="bar.lane + 1"
        [style.--item-color]="bar.item.color" [attr.aria-label]="bar.item.label + ': ' + bar.item.title"
        cdkOverlayOrigin #barOrigin="cdkOverlayOrigin"
        (mouseenter)="hoverKey = 'all|' + bar.item.key" (mouseleave)="hoverKey = null"
        (click)="hoverKey = null; itemClick.emit(bar.item)">
        <mat-icon *ngIf="bar.item.kind === 'outlook'">event_note</mat-icon>
        <mat-icon *ngIf="bar.item.kind === 'absence'">beach_access</mat-icon>
        <span>{{ bar.item.title }}</span>

        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="barOrigin"
          [cdkConnectedOverlayOpen]="hoverKey === 'all|' + bar.item.key" [cdkConnectedOverlayPositions]="tooltipPositions"
          [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12">
          <ng-container *ngTemplateOutlet="tooltipTpl; context: { $implicit: bar.item }"></ng-container>
        </ng-template>
      </button>
    </div>
  </div>

  <!-- Stundenraster -->
  <div class="grid-scroll" #scroll>
    <div class="grid" [style.height.px]="hours.length * hourHeight">
      <div class="hour-labels">
        <span *ngFor="let hour of hours" [style.top.px]="hour * hourHeight">{{ hour | number:'2.0-0' }}:00</span>
      </div>

      <div class="day-col" *ngFor="let day of days; let d = index" [class.today]="day === today"
        [class.weekend]="isWeekend(day)" [class.selectable]="selectable" (pointerdown)="onColumnPointerDown($event, d)">
        <div class="hour-line" *ngFor="let hour of hours" [style.top.px]="hour * hourHeight"></div>

        <div class="selection" *ngIf="selection && selection.day === d"
          [style.top.px]="selection.from / 60 * hourHeight"
          [style.height.px]="(selection.to - selection.from) / 60 * hourHeight"></div>

        <button type="button" class="event" *ngFor="let block of blocksByDay[d]; trackBy: trackItem"
          [ngClass]="block.item.kind" [class.locked]="!block.item.editable && block.item.kind === 'assignment'"
          [class.short]="isShort(block)"
          [style.top.px]="block.top" [style.height.px]="block.height"
          [style.left]="'calc(' + (block.lane * 100 / block.lanes) + '% + 2px)'"
          [style.width]="'calc(' + (100 / block.lanes) + '% - 4px)'"
          [style.--item-color]="block.item.color" [attr.aria-label]="block.item.label + ': ' + block.item.title"
          cdkOverlayOrigin #eventOrigin="cdkOverlayOrigin"
          (mouseenter)="hoverKey = day + '|' + block.item.key" (mouseleave)="hoverKey = null"
          (click)="hoverKey = null; itemClick.emit(block.item)">
          <strong>{{ block.item.title }}</strong>
          <small>{{ timeLabel(block.item) }}</small>

          <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="eventOrigin"
            [cdkConnectedOverlayOpen]="hoverKey === day + '|' + block.item.key && !selection"
            [cdkConnectedOverlayPositions]="tooltipPositions" [cdkConnectedOverlayPush]="true"
            [cdkConnectedOverlayViewportMargin]="12">
            <ng-container *ngTemplateOutlet="tooltipTpl; context: { $implicit: block.item }"></ng-container>
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Gemeinsamer Termin-Tooltip (wie in der Teamplanung) -->
<ng-template #tooltipTpl let-item>
  <app-resource-assignment-tooltip [category]="tooltip(item).category" [title]="item.title"
    [startDate]="item.startDate" [endDate]="item.endDate" [startTime]="item.startTime" [endTime]="item.endTime"
    [allDay]="tooltip(item).allDay" [utilizationPercent]="tooltip(item).utilizationPercent"
    [location]="item.location || null" [footerText]="tooltip(item).footerText" [footerIcon]="tooltip(item).footerIcon">
  </app-resource-assignment-tooltip>
</ng-template>
